<template>
  <div>
    <div class="concat">
      电话：400-107-8586
    </div>
  </div>
</template>

<script>
import store from '../store'
export default {
  name: "Concat",
}
</script>

<style scoped>

.concat {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

</style>